import React, {useState} from "react";
import { Outlet } from "react-router-dom";
import Header from "./Common/Header";
import Sidebar from "./Common/Sidebar";
import Loader from "./../Loader";
import { ToastContainer } from "react-toastify";
import "./../../Public/css/bootstrap.min.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";
import "./../../Public/css/custom_style.css";

const Layout = ({children}) =>
{

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return(
    <div className={`main-wrapper crm-dashboard ${mobileMenuOpen ? "slide-nav" : ""}`}>

        <Loader />

        <Header mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />

        <Sidebar mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />

        <div className="page-wrapper">

            {children}
        </div>

        {mobileMenuOpen && (
            <div className="sidebar-overlay opened" onClick={() => { setMobileMenuOpen(false); document.documentElement.classList.remove("menu-opened"); }} />
        )}

        <ToastContainer />
    </div>


    )
}

export default Layout;
